import {
  DATA,
  CLEAR_DATA,
  START_LOADING,
  STOP_LOADING,
} from "./types";

export const setDataState = (key, data = {}) => (dispatch) => {
  dispatch({
    type: DATA,
    payload: {
      [key]: data,
    },
  });
};

export const clearData = () => ({ type: CLEAR_DATA });

export const startLoading = () => ({ type: START_LOADING });
export const stopLoading = () => ({ type: STOP_LOADING });
